import { COOKIE_ACCESS_TOKEN, cookieStorage } from 'services';
import AxiosInstanceCreator from 'services/api';
import { GET_QNA_MODIFY, GET_QNA_COMMENT, GET_QNA_COMMENT_MODIFY } from '../actions/qna.action';

const qnaInstance = new AxiosInstanceCreator().create();

const accessToken = cookieStorage.getCookie(COOKIE_ACCESS_TOKEN);

export const qnaApi = {
  /**
   * qna 조회 및 검색
   * @param {qnaId, title, content, authorName, readCount, totalComment} data
   * @returns
   */
  async getQnaSearch(data) {
    return await qnaInstance
      .post(`qna/search?page=${data.page}&size=${data.size}`, data)
      .then((res) => res.data);
  },
  /**
   * qna 상세 조회
   * @param {qnaId, title, content, authorName, readCount, totalComment} data
   * @returns
   */
  async getQnaDetail(id) {
    return await qnaInstance.get(`/qna/${id}`).then((res) => res.data);
  },
  /**
   * qna 등록
   * @param {qnaId, title, content, size} data
   * @returns
   */
  async postQna(data) {
    return await qnaInstance
      .post('/qna', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => res.data);
  },

  /**
   * qna 수정
   * @param {qnaModifyDto, files} data
   * @returns
   */
  async updateQna(data) {
    return await qnaInstance
      .post(GET_QNA_MODIFY, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => res.data);
  },

  /**
   * qna 삭제
   * @returns
   */
  async deleteQna(id) {
    return await qnaInstance.delete(`/qna/${id}`).then((res) => res.data);
  },

  /**
   * qna 댓글 등록
   * @param {qnaId, commentContent} data
   * @returns
   */
  async postQnaComment(data) {
    return await qnaInstance.post(GET_QNA_COMMENT, data).then((res) => res.data);
  },

  /**
   * qna 댓글 수정
   * @param {qnaCommentId, commentContent} data
   * @returns
   */
  async updateQnaComment(data) {
    return await qnaInstance.post(`/qna/comment/modify`, data).then((res) => res.data);
  },

  /**
   * qna 댓글 삭제
   * @param  {qnaCommentId}
   * @returns
   */
  async deleteQnaComment(id) {
    return await qnaInstance
      .delete(`/qna/comment/${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then((res) => res.data);
  },

  /**
   * qna 사진 조회
   * @param {fileId} id
   * @returns
   */
  async getQnaPicAPI(id) {
    return await qnaInstance
      .get(`/qna/downloads/${id}`, {
        responseType: 'blob'
      })
      .then((res) => {
        return res.data;
      });
  }
};
